<template>

		<section class="ftco-section">
		<div class="container">
                <div v-if="error">
                <app-message :matn="error_message" ></app-message>
            </div>
			<div class="row justify-content-center">
				<div class="col-md-7 col-lg-4">
					<div class="login-wrap p-4 p-md-5">
		      	<div class="icon d-flex align-items-center justify-content-center">
		      		<span class="fa fa-user-o"></span>
		      	</div>

		      	<h3 class="text-center mb-4">{{ this.$session.get('login') }}</h3>
                <div >
                <v-form @submit.prevent="login"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                     <v-text-field
                    v-model="form.password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="passwordRules"
                    label="Введие пароль"
                    required
                    clearable
                    autofocus

                    ></v-text-field>



	            <div class="form-group mt-4" v-if="!loading">
                    <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 form-control btn btn-primary rounded submit px-3"
                   type="submit"
                    >Войти</v-btn>

	            </div>

                <div class="form-group mt-4" v-if="loading">
                    <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 form-control btn btn-primary rounded submit px-3"
                    ><loading-spin></loading-spin></v-btn>

	            </div>



                     </v-form>

                </div>

	            <div class="form-group d-md-flex">
	            	<div class="w-50">

                            <router-link to="/auth">Авторизация</router-link>
								</div>
								<div class=" w-50 text-md-right">
                                    <router-link to="/forget">Забыли пароль?</router-link>
								</div>


	                </div>

	                </div>
				</div>
			</div>
		</div>
	</section>

</template>

<script>

import axios from 'axios'
import store from '../store'

  export default {


    data: () => ({

        loading: false,
        error: false,
        valid: false,
        show1: false,

        error_message: '',

        form:{
            login: '918291133',
            password: '',
        },



    passwordRules: [
        v => !!v || 'Введите пароль',
        v => (v && v.length >= 3) || 'Пароль должен быть не менее 3 символов',
     //   v=> (v && /[a-z]/.test(v)) || 'Пароль должен содержать минимум одну маленькую букву',
      //  v=> (v && /[A-Z]/.test(v)) || 'Пароль должен содержать минимум одну большую букву',
        v=> (v && /[0-9]/.test(v)) || 'Пароль должен содержать минимум одну цифру',
      //  v=> (v && /[^a-zA-Z0-9]/.test(v)) || 'Пароль должен содержать минимум один специальный символ',
      ],

    }),

    methods: {

       login(){

        axios.post('/api/login', this.form, {
                headers: {
                    "Content-type": "application/json"
                }
            })
                .then(response => {
                    if(response.data.status){

                      //  this.error_message = response.data.nom;
                      // alert(response.data.message);
                       // $this.loading = false;
                        this.$session.start();
                        this.$session.set('id_user', response.data.id_user);
                        this.$session.set('dostup', response.data.dostup);
                        this.$session.set('nom', response.data.nom);
                        this.$session.set('dostup_nom', response.data.dostup_nom);
                        this.$session.set('login', response.data.login);
                        this.$session.set('parol', response.data.parol);

                        this.$store.commit('dostup', response.data.dostup);
                        this.$store.commit('login', response.data.login);
                        this.$store.commit('parol', response.data.parol);

                        this.$router.push({name: 'home'});


                    }else{
                         this.loading  = false;
                        this.error = true;
                        this.error_message = "Ошибка авторизации";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading  = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                });
      }

    },
  }

</script>

<style>

</style>
